import React, { Component, Fragment } from "react";

import {
  Metric,
  Error,
  formatDateFromData,
  isDateFromDataInISOFormat,
} from "./../../../Utils/Utils.js";

import SharedSocialLineChart from "./../../LineGraphs/SharedSocialLineChart/SharedSocialLineChart";

class Twitter extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => {
    const data = this.childRef
      .getExportData()
      .data.map((e) => ({ ...e, name: e.full_date || e.date || e.name }));
    return {
      data: data,
      opts: {
        type: "chart",
        date: {
          name: "name",
          // overwrites the default settings for date only when the date is in ISO format
          defined: isDateFromDataInISOFormat(data),
          format: "YYYY-MM-DDThh:mm:ssZ",
          viewFormat: "YYYY-MM-DD",
        },
        values: ["current_value", "previous_value"],
      },
    };
  };

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    let preparedData = formatDateFromData(
      this.props.data.graph.map((e) => ({ ...e, name: e.full_date || e.name })),
      null,
      "name"
    );
    return (
      <Fragment>
        <div key={"stats"} className="row mb-4">
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Impressions</h6>
            <Metric {...data.stats.impressions} size={"md"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Likes</h6>
            <Metric {...data.stats.likes} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Retweets</h6>
            <Metric {...data.stats.retweets} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Replies</h6>
            <Metric {...data.stats.replies} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Engagements</h6>
            <Metric {...data.stats.engagements} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Video Views</h6>
            <Metric {...data.stats.video_total_views} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">% Complete Views</h6>
            <Metric
              {...data.stats.percent_complete_views}
              size={"sm"}
              type={"percent"}
            />
          </div>
        </div>
        <SharedSocialLineChart
          ref={(el) => (this.childRef = el)}
          data={preparedData}
          color={"#FCD23A"}
        />
      </Fragment>
    );
  }
}

export default Twitter;
